export default "__VITE_ASSET__B5L3G3fX__"